<template>
  <div class="automate">
    <div class="head-box">
      <h4>
        通知模板
      </h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入模板名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="m-l-10" @click.native="doNew">新建模板</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          empty-text="暂无数据"
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <el-table-column label="操作" fixed="right" width="220px">
            <template slot-scope="scope">
              <el-button @click.native.prevent="doEdit(scope.row)" size="mini">
                编辑
              </el-button>
              <el-button
                v-if="scope.row.state == 0"
                @click.native.prevent="doEnable(scope.row._id)"
                type="danger"
                size="mini"
              >
                已禁用
              </el-button>
              <el-button
                v-else
                @click.native.prevent="doDisable(scope.row._id)"
                type="success"
                size="mini"
              >
                已启用
              </el-button>
              <el-button @click.native.prevent="doRemove(scope.row._id)" size="mini">
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="模板名称" width="150px"></el-table-column>
          <el-table-column prop="templateCode" label="模板编号" width="150px"></el-table-column>
          <el-table-column
            prop="channel"
            label="消息通道"
            :formatter="formatChannel"
            width="150px"
          ></el-table-column>
          <el-table-column
            prop="content"
            label="通知内容"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="memo"
            label="备注"
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="通知模板" :visible.sync="openDetail" width="700px">
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="90px"
        label-position="left"
      >
        <el-form-item
          prop="name"
          label="模板名称"
          :rules="{ required: true, trigger: 'blur', message: '模板名称不能为空' }"
        >
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item
          prop="templateCode"
          label="模板编号"
          :rules="{ required: true, trigger: 'blur', message: '模板编号不能为空' }"
        >
          <el-input v-model="formData.templateCode"></el-input>
        </el-form-item>
        <el-form-item
          prop="channel"
          label="消息通道"
          :rules="{ required: true, trigger: 'change', message: '请选择消息渠道' }"
        >
          <el-select
            v-model="formData.channel"
            @change="getParamKey"
            placeholder="请选择消息渠道"
            clearable
          >
            <el-option
              v-for="item in options.channel"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ item.value }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-tag type="success" size="medium">请选择通知参数</el-tag>
        </el-form-item>
        <el-form-item
          v-for="(condition, index) of formData.param"
          :key="index"
          :label="'参数' + (index + 1)"
        >
          <div class="condition-card">
            <el-card shadow="hover">
              <el-form-item
                :label="'参数名 ' + formData.param[index].key"
                required
                label-width="150px"
              >
                <el-select v-model="formData.param[index].key" placeholder="请选择参数名" clearable>
                  <el-option
                    v-for="item in options.paramKey"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">
                      {{ item.value }}
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="参数值" required label-width="150px">
                <el-select
                  v-model="formData.param[index].value"
                  placeholder="参数值支持输入自定义内容"
                  clearable
                  filterable
                  allow-create
                  default-first-option
                >
                  <el-option
                    v-for="item in options.paramValue"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">
                      {{ item.value }}
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-card>
            <div class="card-remove">
              <i class="el-icon-remove" @click="removeCondition(index)"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button plain icon="el-icon-plus" class="button_dashed" @click="newCondition">
            新增通知参数
          </el-button>
        </el-form-item>
        <el-form-item
          prop="content"
          label="通知内容"
          :rules="{ required: true, trigger: 'blur', message: '通知内容不能为空' }"
        >
          <el-input
            v-model="formData.content"
            type="textarea"
            placeholder="请填写通知内容"
          ></el-input>
        </el-form-item>
        <el-form-item prop="memo" label="备注">
          <el-input v-model="formData.memo" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Allot',
  data() {
    window.$this = this;
    return {
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        param: [{ key: '', value: '' }]
      },
      rules: this.$util.rules,
      options: {
        codecfg_channel: { codeId: 'noticationChannel' },
        codecfg_paramValue: { codeId: 'notificationParam' }
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.codeoption(() => {
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        param: [{ key: '', value: '' }]
      };
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#and': this.searchValue,
        channel: this.channel,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('notification/template/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      let formData = this.$util.deepCopy(row);
      // param对象转数组
      let param = [];
      for (let key in formData.param || []) {
        param.push({ key: key, value: formData.param[key] });
      }
      formData.param = param;

      this.formData = formData;
      this.getParamKey(this.formData.channel, true);
      this.openDetail = true;
    },
    doSave() {
      let params = this.$util.deepCopy(this.formData);

      //param数组转对象
      let obj = {};
      for (let item of params.param) {
        if (!item.key) {
          this.osg.toast('请选择参数名');
          return;
        }
        if (!item.value) {
          this.osg.toast('请选择参数值');
          return;
        }
        obj[item.key] = item.value;
      }
      params.param = obj;

      if (this.osg.validate()) {
        this.osg.ajax('notification/template/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`notification/template/enable/${id}.do`, null, () => {
        this.osg.toast('启用成功');
        this.getData();
      });
    },
    doDisable(id) {
      this.osg.ajax(`notification/template/disable/${id}.do`, null, () => {
        this.osg.toast('禁用成功');
        this.getData();
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`notification/template/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //新增参数
    newCondition() {
      this.formData.param.push({
        key: '',
        value: ''
      });
    },
    //删除参数
    removeCondition(index) {
      this.formData.param.splice(index, 1);
    },
    //获取字典表
    getParamKey(codeType, edit) {
      if (!edit) {
        debugger;
        this.formData.param = [{ key: '', value: '' }];
      }
      this.options['codecfg_paramKey'] = { codeId: codeType + 'Param' };
      this.osg.codeoption(() => {
        this.$forceUpdate();
      });
    },
    formatChannel(row, column, cellValue) {
      return this.osg.codelabel('channel', cellValue);
    }
  }
};
</script>
<style>
.condition-card {
  display: flex;
  justify-content: space-between;
}
.condition-card .el-card {
  width: 90% !important;
}
.condition-card .card-remove {
  width: 10%;
  text-align: center;
  color: #f2795b;
  cursor: pointer;
  font-size: 18px;
}
.automate .el-dialog__body {
  padding: 20px 30px;
}
</style>
